<template>
  <div>
    <div class="material-master-table--container">
      <div class="copy-dtx-table">
        <table>
          <thead>
            <tr>
              <th v-overflow-tooltip>Job Order</th>
              <th v-overflow-tooltip>Product Code</th>
              <th v-overflow-tooltip>Material Name</th>
              <th v-overflow-tooltip>Company</th>
              <th v-overflow-tooltip>Current Stage name</th>
              <th v-overflow-tooltip>Status</th>
              <th v-overflow-tooltip>Users</th>
              <th v-overflow-tooltip>Created On</th>
              <th v-overflow-tooltip>Priority</th>
              <th class="qr-header">QR</th>
              <th v-overflow-tooltip class="qc-header">QC</th>
              <th v-overflow-tooltip>Actions</th>
            </tr>
          </thead>
          <tbody>
            <!-- No Data Found Row -->
            <tr v-if="!itemMasterList || itemMasterList.length === 0">
              <td colspan="10" class="no-data-cell">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  No Data Found
                </div>
              </td>
            </tr>
            <!-- Regular Data Rows -->
            <tr
              v-for="(mm, index) in itemMasterList"
              :key="mm?.id || Math.random()"
              :class="{ 'disabled-dd': Object.keys(selectedTransition).length && !selectedTransition?.[index]?.id, 'selected-row': Object.keys(selectedTransition).length && selectedTransition?.[index]?.id }"
            >
              <!-- Seqeunce -->
              <td
                class="elipsis-text"
                v-overflow-tooltip
              >
                {{
                   mm?.job_order_sequence || "--"
                }}
              </td>
              <!-- Product Code -->
              <td
                class="elipsis-text"
                v-overflow-tooltip
                :title="mm?.product_code || '--'"
                @dblclick="viewMaterialInstance(mm, index)"
              >
                {{
                  mm?.product_code && mm.product_code.length > 9
                    ? mm.product_code.substring(0, 9) + "..."
                    : mm?.product_code || "--"
                }}
              </td>
              <td
                class="elipsis-text material-name-cell"
                v-overflow-tooltip
                @dblclick="viewMaterialInstance(mm, index)"
              >
                {{ mm?.material_name || "--" }}
              </td>
              <!-- Company Name -->
              <td
                class="elipsis-text"
                v-overflow-tooltip
                @dblclick="viewMaterialInstance(mm, index)"
              >
                {{ mm?.company_name || "--" }}
              </td>
              <!-- Current Stage Name -->
              <td
                class="elipsis-text"
                v-overflow-tooltip
                @dblclick="viewMaterialInstance(mm, index)"
              >
                <span
                  v-if="
                    mm?.current_workflow_step &&
                    typeof mm.current_workflow_step === 'object'
                  "
                >
                  {{ mm.current_workflow_step.name || "--" }}
                </span>
                <span v-else-if="mm?.current_workflow_step">
                  {{ mm.current_workflow_step || "--" }}
                </span>
                <span v-else>--</span>
              </td>
              <td v-overflow-tooltip @dblclick="viewMaterialInstance(mm, index)">
                <span
                  class="state-label"
                  :class="getStatusClass(mm?.workflow_state)"
                >
                  {{ mm?.workflow_state || "--" }}
                </span>
              </td>
              <!-- Users (First name + Last name) -->
              <td
                class="elipsis-text"
                @dblclick="viewMaterialInstance(mm, index)"
              >
                <div
                  v-if="mm?.core_user_group_members?.length"
                  class="avatar-container"
                >
                  <avatar
                    v-for="(member, memberIndex) in mm.core_user_group_members"
                    :key="memberIndex"
                    :user="member?.core_user"
                    :title="getUserTooltip(member?.core_user)"
                    style="margin-right: -13.5px"
                  />
                </div>
                <div class="avatar-container" v-else-if="mm.workflow_state === 'COMPLETED'">
                  <avatar
                    v-for="(member, memberIndex) in mm.workflow_instance.transition_history[0].current_workflow_step.core_user_group.core_user_group_members"
                    :key="memberIndex"
                    :user="member?.core_user"
                    :title="getUserTooltip(member?.core_user)"
                    style="margin-right: -13.5px"
                  />
                </div>
              </td>
              <td v-overflow-tooltip @dblclick="viewMaterialInstance(mm, index)">
                <span v-if="mm?.created_on">
                  {{ mm.created_on | genericFormatDate }}
                </span>
                <span v-else>--</span>
              </td>
              <td v-overflow-tooltip @dblclick="viewMaterialInstance(mm, index)">
                <span
                  v-if="mm?.priority"
                  class="priority-label"
                  :class="getPriorityClass(mm.priority)"
                >
                  {{ getPriorityName(mm.priority) }}
                </span>
                <span v-else>--</span>
              </td>
                       <td class="qr-cell">
                      <button
                        type="button"
                        class="qr-code-btn"
                        :class="{ 'qr-disabled': !mm?.bar_code_blob_key }"
                        v-tooltip="mm?.bar_code_blob_key ? 'Show QR Code' : 'QR not available'"
                        @click.stop.prevent="handleQrClick(mm, mm.material_id, index)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke= "rgb(74, 144, 226)"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          style="display: block;"
                        >
                          <rect x="3" y="3" width="7" height="7" />
                          <rect x="14" y="3" width="7" height="7" />
                          <rect x="3" y="14" width="7" height="7" />
                          <path d="M14 14h7v7h-7z" />
                          <path d="M17 17v-3" />
                          <path d="M17 17h3" />
                        </svg>
                      </button>
                    </td>
              <!-- QC Column -->
              <td v-overflow-tooltip @dblclick="viewMaterialInstance(mm, index)">
                <button
                  @click.stop="fillQC(mm, index)"
                  class="fill-qc-btn"
                  v-if="mm?.workflow_instance?.transition_history[0]?.current_workflow_step?.qc_parent_step_id && mm?.workflow_state !== 'COMPLETED' && mm.editInstance
                  "
                >
                  Fill QC
                </button>
                <button
                  @click.stop="viewQCHistory(mm, index)"
                  class="fill-qc-btn"
                  v-else-if="mm?.workflow_instance?.transition_history[0]?.current_workflow_step?.qc_parent_step_id && mm?.workflow_state === 'COMPLETED'
                  "
                >
                View QC
                </button>
                <span v-else>--</span>
              </td>
              <!-- Actions Column -->
              <td class="actions-cell">
              <div class="actions-wrapper">
                  <!-- Workflow Closed State -->
                  <div
                    v-if="mm?.workflow_state === 'COMPLETED'"
                    class="workflow-closed"
                  >
                    <span class="checkmark-icon">✓</span>
                    <span class="workflow-text">Workflow Closed</span>
                  </div>
                  <!-- Active Workflow with Advanced Dropdown -->
                  <div v-else-if="mm.editInstance && (mm?.qc_parent_step_id && [Config.FORM_STATE_MAP.APPROVED,Config.FORM_STATE_MAP.REJECTED].includes(mm.qc_form_status)|| !mm?.qc_parent_step_id && mm?.workflow_state === 'ONGOING')" class="action-dropdown">
                    <div class="dropdown-container">
                      <custom-dropdown
                        :list="  !mm.workflow_instance?.transition_history[0]?.current_workflow_step?.qc_parent_step_id && !mm.end_step
                        ? mm.next_transition
                        : mm.workflow_instance?.transition_history[0]?.current_workflow_step?.qc_parent_step_id && !mm.end_step && mm.qc_form_status === Config.FORM_STATE_MAP.APPROVED
                        ? mm.next_transition.filter(item => item.next_workflow_stage.id !== mm.qc_parent_step_id)
                        : mm.workflow_instance?.transition_history[0]?.current_workflow_step?.qc_parent_step_id && !mm.end_step && mm.qc_form_status === Config.FORM_STATE_MAP.REJECTED
                        ? mm.next_transition.filter(item => item.next_workflow_stage.id === mm.qc_parent_step_id)
                        : mm.workflow_instance?.transition_history[0]?.current_workflow_step?.qc_parent_step_id && mm.end_step && mm.qc_form_status === Config.FORM_STATE_MAP.APPROVED
                        ? [{ name: 'Finish workflow', id: 'finish' }]
                        : !mm.workflow_instance?.transition_history[0]?.current_workflow_step?.qc_parent_step_id && mm.end_step
                        ? [{ name: 'Finish workflow', id: 'finish' }]
                        : mm.workflow_instance?.transition_history[0]?.current_workflow_step?.qc_parent_step_id && mm.end_step && mm.qc_form_status === Config.FORM_STATE_MAP.REJECTED
                        ? mm.next_transition.filter(item => item.next_workflow_stage.id === mm.qc_parent_step_id)
                        : mm.next_transition
                        "
                        @select="
                          (transition) => {
                            selectedTransition = { [index]: transition };
                          }
                        "
                        :selected="selectedTransition[index] ?? {}"
                        :defaultLabel="'Choose action to apply...'"
                        :defaultStyle="{
                          dropDownWidth: '10rem',
                          backGroundColor: 'transparent',
                          borderColor: '#e6e9ef',
                        }"
                      />

                      <!-- Save and Cancel Buttons -->
                      <div
                        v-if="selectedTransition[index]"
                        class="action-buttons"
                      >
                        <button
                          class="save-btn"
                          @click.stop="saveSelectedTransition(mm, index)"
                          :disabled="!selectedTransition[index].id"
                        >
                          Save
                        </button>
                        <button
                          class="btn-cancel"
                          @click.stop="cancelTransition(mm)"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex space-between pagination-section">
        <pagination-2
          class="mt-2"
          :length="totalCount"
          :pageNumber="pageNumber"
          :perPage="perPage"
          @selectPage="$emit('selectPage', $event)"
        />
        <div class="total-count mt-2">
          <span
            >Total Items : &nbsp; <b> {{ totalCount }}</b></span
          >
        </div>
      </div>
    </div>

    <!-- QC Inspection Dialog -->
    <!-- the fisrt option (eg: selectedItem.qcformId) is to handle  view Pat forms  directed from qc history modal -->
    <QCInspectionDialog
      v-if="showQCDialog"
      :qcTemplateId="
        selectedItem.qcTemplateId ||
        selectedItem?.workflow_instance?.transition_history[0]
          ?.current_workflow_step?.qc_form_template_id
      "
      :qcformId="
        selectedItem.qcformId ||
        selectedItem?.workflow_instance?.transition_history[0]?.form_id
      "
      :stepName="
        selectedItem.stepName ||
        selectedItem?.workflow_instance?.transition_history[0]
          ?.current_workflow_step?.name ||
        '--'
      "
      :edit="selectedItem.edit"
      @save="onQCSave"
      @close="closeQCDialog"
      @showQCHistory="handleQCHistory"
    />

    <!-- QC History Dialog -->
    <QCIterationListDialog
      v-if="showQCHistoryDialog"
      :iterations="stepHistory"
      :stepHistory="stepHistory"
      :stepId="selectedItem.step_id"
      :instanceId="selectedItem.instance_id"
      :showFillInspection="selectedItem.edit"
      @close="closeQCHistoryDialog"
      @viewInspection="viewInspection"
      @updateQcform="updateQcform"
    />
         <!-- QR Code Modal -->
    <modal
      :open="qrCodeModal"
      title="Material Instance QR Code"
      :closeOnOutsideClick="true"
      @close="closeQRCodeModal"
    >
      <div class="qr-modal-content">
        <div class="qr-code-container">
          <div class="qr-code-display">
            <div v-if="loadingQRCode" class="qr-loading">
              <loading-circle />
              <p>Loading QR Code...</p>
            </div>
            <img
              v-else-if="selectedInstanceQR"
              :src="selectedInstanceQR"
              :alt="`QR Code for ${selectedInstanceForQR?.materialName}`"
            />
            <p v-else class="qr-missing">QR not available</p>
          </div>
          <div class="qr-info">
            <p class="qr-info-title">
              {{ selectedInstanceForQR?.materialName }}
            </p>
            <!-- <p class="qr-info-subtitle">Instance ID: {{ selectedInstanceForQR?.id }}</p> -->
            <p class="qr-info-subtitle">Current Step: {{ selectedInstanceForQR?.stepName || '--' }}</p>
          </div>
        </div>
        <div class="qr-actions">
          <button
            class="btn btn-black mr-3"
            @click="downloadInstanceQRCode"
            :disabled="loadingQRCode || !selectedInstanceForQR?.bar_code_blob_key"
          >
            Download QR Code
          </button>
          <button class="btn" @click="closeQRCodeModal">
            Close
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  updateWorkFlowActionApi,
  GetMaterialElement,
  getWfStepHistory,
  generateS3DownloadingUrlSingle
} from '@/api'
import { genericFormatDate } from '@/utils/date'
import { getTokenStorage, projectExchangeToken } from '@/api/session'
import avatar from '../common/avatar.vue'
import pagination2 from '../common/pagination2.vue'
import { success, alert } from '@/plugins/notification'
import { mapGetters } from 'vuex'
import Config from '@/config'
import QCInspectionDialog from './qcInspectionDialog.vue'
import QCIterationListDialog from './qcIterationListDialog.vue'
import CustomDropdown from '../common/customDropdown.vue'
import Loader from '@/plugins/loader'
import Modal from '../common/modal.vue'
import LoadingCircle from '../common/loadingCircle.vue'
export default {
  components: {
    pagination2,
    avatar,
    QCInspectionDialog,
    QCIterationListDialog,
    CustomDropdown,
    Modal,
    LoadingCircle
  },
  name: 'materialMasterTable',
  filters: {
    genericFormatDate
  },
  props: {
    view: {
      type: String
    },
    itemMasterList: {
      type: Array,
      default: () => []
    },
    materialMasterList: {
      type: Array,
      default: () => []
    },
    pageNumber: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 20
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    resourceStateValues: [],
    activeMenuIndex: null,
    transitionModeIndex: null,
    selectedAction: '',
    selectedTransition: {},
    showQCDialog: false,
    showQCHistoryDialog: false,
    selectedItem: null,
    // Hardcoded QC iterations data
    stepHistory: [],
    availableTransitions: [
      { id: 1, name: 'Approve' },
      { id: 2, name: 'Reject' },
      { id: 3, name: 'Review' },
      { id: 4, name: 'Complete' }
    ],
    activeIndex: null,
    list_of_unit_of_material: {},
    Config: Config,
    materialPriority: [],
    qrCodeModal: false,
    selectedInstanceForQR: null,
    selectedInstanceQR: '',
    loadingQRCode: false
  }),
  computed: {
    ...mapGetters(['user', 'getUserById']),
    ...mapGetters([
      'isTenantAdmin',
      'isProjectAdmin',
      'isTenantViewer',
      'isProjectViewer',
      'isOnProjectLevel',
      'collaborator'
    ]),
    showEditButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR' ||
          this.user.tenantLevelRole === 'EDITOR') &&
        !this.isOnProjectLevel &&
        !this.collaborator
      )
    },
    showLockButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR') &&
        !this.isOnProjectLevel &&
        !this.collaborator
      )
    },
    showUnLockButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
          this.user.tenantLevelRole === 'COLLABORATOR') &&
        !this.isOnProjectLevel &&
        !this.collaborator
      )
    },
    showObsoleteButton () {
      return (
        this.user.tenantLevelRole === 'ADMIN' &&
        !this.isOnProjectLevel &&
        !this.collaborator
      )
    },
    showActiveButton () {
      return (
        this.user.tenantLevelRole === 'ADMIN' &&
        !this.isOnProjectLevel &&
        !this.collaborator
      )
    }
  },
  methods: {
    cancelTransition (mm) {
      this.selectedTransition = {}
    },

    async saveSelectedTransition (mm, index) {
      if (index === null || index === undefined) {
        return
      }

      const selected = this.selectedTransition[index]
      if (!selected) {
        return
      }
      // Check if resources are required but not selected
      const resourcesRequired = mm.workflow_step_resources_associations?.length > 0
      const resourcesSelected = mm.instance_step_resources?.length > 0
      if ((resourcesRequired && !resourcesSelected) && (mm.trigger_actions?.mandatory && mm.step_attachments.length === 0)) {
        alert('Mandatory fields are pending ')
        return
      } else if (resourcesRequired && !resourcesSelected) {
        alert('Resources are pending ')
        return
      } else if (mm.trigger_actions?.mandatory && mm.step_attachments.length === 0) {
        alert('File upload is pending ')
        return
      }

      try {
        if (selected.id === 'finish') {
          await this.finishWorkflow(mm, null)
        } else {
          await this.executeTransition(mm, null, selected)
        }
        // Clear selection and close dropdown only after successful save
        this.selectedTransition = {}
      } catch (error) {
        // Don't close dropdown on error so user can try again
      }
    },

    async executeTransition (mm, index, transition) {
      if (!transition) {
        return
      }
      const loader = new Loader()
      loader.show()
      const transitionId = transition.id || transition

      const body = {
        input: {
          metadata: {
            attachments: []
          },
          close_workflow: undefined,
          history_id: mm?.history_id,
          instance_id: mm?.instance_id,
          action_taken: transitionId,
          next_step_assignees: undefined,
          delete_step_assignees: undefined
        }
      }

      try {
        const response = await updateWorkFlowActionApi(body)
        if (
          response &&
          response.message &&
          response.message.message === 'History updated successfully'
        ) {
          this.$emit('updateList')
          success('Transition executed successfully')
          this.selectedTransition = ''
        } else {
          alert(response.message ?? 'Failed to execute transition')
        }
        loader.hide()
      } catch (error) {
        loader.hide()
        alert('Failed to execute transition')
        throw error // Re-throw so saveSelectedTransition can handle it
      }
    },

    async finishWorkflow (mm, index) {
      const loader = new Loader()
      loader.show()
      // Execute the finish workflow using the existing saveTransition logic
      const body = {
        input: {
          metadata: {
            attachments: []
          },
          close_workflow: true,
          history_id: mm?.history_id,
          instance_id: mm?.instance_id,
          action_taken: null,
          next_step_assignees: undefined,
          delete_step_assignees: undefined
        }
      }

      try {
        const response = await updateWorkFlowActionApi(body)
        loader.hide()
        if (
          response &&
          response.message &&
          response.message.message === 'History updated successfully'
        ) {
          if (response.message?.form_id) {
            this.$router.push(`/forms/template/${response?.message?.form_template_id}/form/${response?.message?.form_id}/edit`)
          }
          this.$emit('updateList')
          success('Workflow finished successfully')
        } else {
          alert('Failed to finish workflow')
        }
      } catch (error) {
        loader.hide()
        alert('Failed to finish workflow')
        throw error // Re-throw so saveSelectedTransition can handle it
      }
    },
    viewMaterialInstance (mm, index) {
      const storage = getTokenStorage()
      const prevProjectId = storage.getItem('projectId')
      const newProjectId = mm.project_id

      const navigateToForm = () => {
        const templateId = mm?.template_id
        const formId = mm?.form_id
        const workflowInstanceId = mm?.instance_id || mm?.wfInstanceId

        if (workflowInstanceId) {
          this.$router.push({
            path: `/forms/template/${templateId}/form/${formId}/view`,
            query: { mInst: workflowInstanceId }
          })
        } else {
          this.$router.push(`/forms/template/${templateId}/form/${formId}/view`)
        }
      }
      if (mm.project_id) {
        const storage = getTokenStorage()
        storage.setItem('projectId', mm.project_id)
        projectExchangeToken(() => {
          // Check if project has changed
          if (parseInt(prevProjectId) !== parseInt(newProjectId)) {
            // Project changed - need to call setup
            this.$store.dispatch('setup', () => {
              navigateToForm()
            })
          } else {
            // Same project - just get current project
            this.$store.dispatch('getCurrentProject', () => {
              navigateToForm()
            })
          }
        }, mm.project_id)
      } else {
        // No project_id - remove project token and navigate
        const storage = getTokenStorage()
        storage.removeItem('dtxProjectToken')
        storage.removeItem('projectId')

        // If we had a project before, need to call setup to reset state
        if (prevProjectId) {
          this.$store.dispatch('setup', () => {
            navigateToForm()
          })
        } else {
          navigateToForm()
        }
      }
    },

    getUserTooltip (user) {
      if (!user) return ''
      return `${user?.first_name || ''} ${user?.last_name || ''}`
    },
    getStatusClass (status) {
      switch (status) {
      case 'ONGOING':
        return 'status-locked'
      case 'COMPLETED':
        return 'status-active'
      default:
        return ''
      }
    },
    getPriorityName (priorityId) {
      return (
        this.materialPriority.find((el) => el.id === priorityId)?.name || '--'
      )
    },
    getPriorityClass (priorityId) {
      const priorityName = this.getPriorityName(priorityId).toLowerCase()
      if (priorityName.includes('highest') || priorityName.includes('urgent')) {
        return 'priority-highest'
      } else if (priorityName.includes('high')) {
        return 'priority-high'
      } else if (
        priorityName.includes('medium') ||
        priorityName.includes('med')
      ) {
        return 'priority-medium'
      } else if (
        priorityName.includes('lowest') ||
        priorityName.includes('minimal')
      ) {
        return 'priority-lowest'
      } else if (priorityName.includes('low')) {
        return 'priority-low'
      }
      return 'priority-default'
    },
    async getElementList () {
      await GetMaterialElement().then((res) => {
        this.materialPriority = res.custom_list_values
      })
    },
    async fillQC (mm, index) {
      this.selectedItem = mm
      this.selectedItem.edit = true
      const formId = mm?.workflow_instance?.transition_history[0]?.form_id
      const loader = new Loader()
      loader.show()
      try {
        const stepHistory = await this.getWorkflowHistory()
        this.stepHistory = stepHistory.message.data
        loader.hide()
        // this is condition if the qc has been rejected and we are coming to fill the qc again then need to show the qc history qc history modal
        if (stepHistory.message.data.length > 0) {
          this.handleQCHistory()
          return
        }
      } catch (error) {
        console.log(error)
        loader.hide()
        alert('Something went wrong')
      }
      // Show QC Inspection Dialog directly
      this.showQCDialog = true
      if (formId) {
        this.updateURLWithFormId(formId)
      }
    },

    updateURLWithFormId (formId) {
      // Update URL to include form ID as a query parameter
      const currentUrl = new URL(window.location)
      currentUrl.searchParams.set('qc_form_id', formId)

      // Update the URL without reloading the page
      window.history.pushState({}, '', currentUrl.toString())
    },

    clearFormIdFromURL () {
      // Remove form ID from URL when closing the dialog
      const currentUrl = new URL(window.location)
      currentUrl.searchParams.delete('qc_form_id')

      // Update the URL without reloading the page
      window.history.pushState({}, '', currentUrl.toString())
    },

    checkURLForFormId () {
      // Check if there's a form ID in the URL query parameters
      const urlParams = new URLSearchParams(window.location.search)
      const formId = urlParams.get('qc_form_id')

      if (formId) {
        // You could implement logic here to find the corresponding material item
        // and automatically open the QC dialog if needed
      }
    },

    closeQCDialog () {
      this.showQCDialog = false
      this.selectedItem = {}
      // Clear form ID from URL when closing dialog
      this.clearFormIdFromURL()
    },

    handleQCHistory (qcData) {
      this.showQCDialog = false
      this.showQCHistoryDialog = true
    },

    closeQCHistoryDialog () {
      this.showQCHistoryDialog = false
      this.selectedItem = null
    },

    onQCSave (inspectionData) {
      // Here you can send the data to your backend API
      // For now, just show a success message
      this.$emit('updateList')
      success('QC Inspection saved successfully!')
      this.closeQCDialog()
    },
    selectionChange (index, toggle) {
      this.activeIndex = index
      // this.selectedTransition = {}
    },
    getWorkflowHistory () {
      return getWfStepHistory(
        this.selectedItem.instance_id,
        this.selectedItem.step_id
      )
    },
    viewInspection (formData) {
      this.selectedItem.qcformId = formData.qcformId
      this.selectedItem.stepName = formData.operation
      this.selectedItem.qcTemplateId = formData.qcTemplateId
      this.updateURLWithFormId(formData.qcformId)
      this.showQCHistoryDialog = false
      this.selectedItem.edit = false
      this.showQCDialog = true
    },
    updateQcform (formData) {
      this.selectedItem.qcformId = formData.qcformId
      this.selectedItem.stepName = formData.operation
      this.selectedItem.qcTemplateId = formData.qcTemplateId
      this.updateURLWithFormId(formData.qcformId)
      this.showQCHistoryDialog = false
      this.selectedItem.edit = true
      this.showQCDialog = true
    },
    async viewQCHistory (mm, index) {
      this.selectedItem = mm
      this.selectedItem.edit = false
      this.selectedItem.step_id = mm?.current_workflow_step?.step_id
      const stepHistory = await this.getWorkflowHistory()
      this.stepHistory = stepHistory.message.data
      this.handleQCHistory()
    },
    async handleQrClick (material, materialId, index) {
      if (!material?.bar_code_blob_key) return
      this.showInstanceQRCode(material, materialId, index)
    },
    async showInstanceQRCode (material, materialId, index) {
      if (!material?.bar_code_blob_key) {
        alert('QR Code not available for this workflow instance')
        return
      }
      this.qrCodeModal = true
      this.loadingQRCode = true
      this.selectedInstanceForQR = {
        ...material,
        stepName: material?.current_workflow_step?.name,
        materialName: material?.material_name || '--'
      }
      this.selectedInstanceQR = ''
      try {
        const response = await generateS3DownloadingUrlSingle({
          fileName: encodeURIComponent(`${this.selectedInstanceForQR.materialName || 'material'}-${this.selectedInstanceForQR.sequence}-qr.png`),
          S3Key: material.bar_code_blob_key
        })
        if (response?.url) {
          this.selectedInstanceQR = response.url
        } else {
          throw new Error('Failed to fetch S3 URL')
        }
      } catch (error) {
        console.error('Error loading QR code:', error)
        alert('Failed to load QR code from S3')
        this.closeQRCodeModal()
      } finally {
        this.loadingQRCode = false
      }
    },
    closeQRCodeModal () {
      this.qrCodeModal = false
      this.selectedInstanceForQR = null
      this.selectedInstanceQR = ''
      this.loadingQRCode = false
    },
    async downloadInstanceQRCode () {
      if (!this.selectedInstanceForQR?.bar_code_blob_key || this.loadingQRCode) return
      try {
        this.loadingQRCode = true
        const response = await generateS3DownloadingUrlSingle({
          fileName: `material-${this.selectedInstanceForQR.materialName || 'instance'}-${this.selectedInstanceForQR.sequence}-qr.png`,
          S3Key: this.selectedInstanceForQR.bar_code_blob_key
        })
        if (response?.url) {
          const res = await fetch(response.url)
          const blob = await res.blob()
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `material-${this.selectedInstanceForQR.materialName || 'instance'}-${this.selectedInstanceForQR.sequence}-qr.png`
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          throw new Error('Failed to fetch S3 URL')
        }
      } catch (error) {
        console.error('Error downloading QR code:', error)
        alert('Failed to download QR code')
      } finally {
        this.loadingQRCode = false
      }
    }
  },
  async mounted () {
    this.getElementList()
    // Check if there's a form ID in the URL and open QC dialog if needed
    this.checkURLForFormId()
  },
  watch: {
    '$route.query.selectedMaterialId' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.MaterialList(this.materialMasterList)
      }
    },
    materialMasterList: {
      immediate: true,
      handler (newList) {
        if (newList.length) {
          this.MaterialList(newList)
        }
      }
    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-container {
  display: flex;
  align-items: center;
}

// .action-menu-cell {
//   position: relative;
//   overflow: visible !important;
// }

.action-menu-wrapper {
  position: relative;
  display: inline-block;
}

.transition-controls {
  display: flex;
  align-items: center;
}
.sort {
  height: 1.7em;
  width: 7rem;
  // margin: 2px 10px 0 10px;
  // margin-left: 2px;
  font-size: var(--text-base);
  background-color: var(--brand-light-color);
  line-height: 1;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  padding: 4px 6px;
}
// .transition-dropdown {
//   min-width: 150px;
//   padding: 4px 8px;
//   font-size: var(--text-m);
//   border: 1px solid #d0d0d0;
//   border-radius: 4px;
//   background-color: white;
//   cursor: pointer;

//   &:focus {
//     outline: none;
//     border-color: var(--brand-color);
//   }
// }

.action-icon {
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
}

.dropdown-menu {
  position: fixed;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 160px;
  z-index: 9999;
  overflow: hidden;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: var(--text-base);
  color: #333;

  &:hover {
    background-color: #f5f5f5;
  }

  .dropdown-icon {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  span {
    white-space: nowrap;
  }
}
.icon-img {
  width: 12px;
  height: 12px;
  margin-top: 1px;
}
.status {
  font-size: var(--text-m);
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  padding: 3px 4px;
  border-radius: 3px;
  background-color: orange;
  &-locked {
    background-color: #fff3cd;
    color: #856404;
  }
  &-hold {
    background-color: #cce5ff;
    color: #004085;
  }
  &-active {
    background-color: #d4edda;
    color: #155724;
  }
  &-obselete {
    background-color: #ffcccc;
    color: #d60000;
  }
}
.total-count {
  background-color: #f1f3f5;
  padding: 0.5rem 0.5rem 0.5rem;
  border: 1px solid #f1f3f5;
  border-radius: 0.2em;
  width: fit-content;
  padding-inline: 10px;
  margin-left: auto;
}

.mm-table {
  th {
    z-index: 4;
  }

  .chip {
    img {
      width: 10px;
      height: 100%;
      z-index: 5;
    }

    padding: 2px 8px;
    font-size: var(--text-xs1);
    background-color: rgba(var(--brand-rgb), 0.5);
    z-index: 0;
    border-radius: 2px;
    position: relative;

    &-popover {
      position: absolute;
      width: 145px;
      height: 81px;
      background: transparent;
      top: -30px;
      z-index: 4;
      display: flex;
      justify-content: start;
      transform: translateX(30%);

      & img {
        width: auto;
        height: 100%;
        object-fit: fill;
        border: 1px solid rgb(51, 40, 40, 0.5);
        border-radius: 4px;
        -webkit-box-shadow: -11px 4px 49px -32px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: -11px 4px 49px -32px rgba(0, 0, 0, 0.75);
        box-shadow: -11px 4px 49px -32px rgba(0, 0, 0, 0.75);
      }
    }
  }

  .thumbnail {
    width: 60px;
    height: 60px;
  }
}

.custom-list-select {
  max-width: 100%;
  min-width: 20%;
  margin-right: auto;
  font-size: var(--text-s);
  background-color: var(--brand-light-color);
  line-height: 1;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  padding: 2px 1px;
}

.obsolete-row {
  background-color: var(--gray);
}

.material-master-table {
  &--table {
    max-height: calc(100vh - 250px);
  }

  &--container {
    max-height: calc(100% - 60px);
    overflow: auto;

    table {
      table-layout: auto;
      th,
      td {
        max-width: 100px;
        // overflow: visible;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      td:last-child {
        max-width: fit-content;
      }

      .action-cell {
        min-width: 200px;
        max-width: 250px;
      }

      .column {
        padding: 10px 8px;
      }

      .edit-1 {
        margin: 0 2px;
      }
    }
  }

  .pagination-footer {
    padding-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    &-total {
      margin-top: 16px;
      display: flex;
      background: #f1f3f5;
      padding: 0.5rem 0.5rem 0.5rem;
      border: 1px solid #f1f3f5;
      border-radius: 0.2em;
      width: fit-content;
      padding-inline: 10px;
      margin-left: auto;
    }
  }

  .productbom-title {
    color: var(--text-color-1);
    font-weight: 500;
    font-size: 0.9em;
  }

  .btn {
    color: var(--white);
  }

  .redColor {
    color: red;
  }

  .attachments {
    z-index: 1;
  }
}

.fill-qc-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f5f5f5;
  color: rgb(0, 0, 0);
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: var(--text-s);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(158, 158, 158, 0.3);
  box-shadow: 0 1px 2px rgba(102, 126, 234, 0.2);

  &:hover {
    background: #e8e8e8;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(211, 219, 255, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(189, 191, 197, 0.2);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(189, 191, 197, 0.3);
  }

  .btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 12px;
      height: 12px;
      color: #666;
    }
  }

  .btn-text {
    font-weight: 400;
    letter-spacing: 0.3px;
  }
}

.priority-label {
  display: inline-block;
  padding: 3px 6px;
  border-radius: 10px;
  font-size: var(--text-xs1);
  font-weight: 500;
  text-align: center;
  border: 1px solid;

  &.priority-highest {
    background-color: #ffebee;
    color: #b71c1c;
    border-color: #ffcdd2;
    font-weight: 600;
  }

  &.priority-high {
    background-color: #ffebee;
    color: #c62828;
    border-color: #ffcdd2;
  }

  &.priority-medium {
    background-color: #fff8e1;
    color: #f57c00;
    border-color: #ffecb3;
  }

  &.priority-low {
    background-color: #e8f5e8;
    color: #2e7d32;
    border-color: #c8e6c9;
  }

  &.priority-lowest {
    background-color: #f3e5f5;
    color: #7b1fa2;
    border-color: #e1bee7;
    font-weight: 400;
  }

  &.priority-default {
    background-color: #f5f5f5;
    color: #616161;
    border-color: #e0e0e0;
  }
}

.state-label {
  display: inline-block;
  padding: 3px 6px;
  border-radius: 10px;
  font-size: var(--text-xs1);
  font-weight: 500;
  text-align: center;
  border: 1px solid;

  &.status-active {
    background-color: #e8f5e8;
    color: #2e7d32;
    border-color: #c8e6c9;
  }

  &.status-locked {
    background-color: #fff8e1;
    color: #f57c00;
    border-color: #ffecb3;
  }
}

// Table cell styling
.material-master-table--table {
  td {
    font-size: var(--text-xs2);
    font-weight: 400;
    padding: 8px 12px;

    &.material-name-cell {
      font-weight: 500;
    }
  }

  th {
    font-size: var(--text-s);
    font-weight: 600;
    padding: 8px 12px;
    height: auto;
  }
}

// Actions column styling
.actions-cell {
  padding: 8px 12px;
  width: 280px;
  min-width: 280px;
  max-width: 280px !important;
  overflow: visible !important;
  position: relative;

  // Override table cell overflow
  overflow: visible !important;
  text-overflow: initial !important;
  white-space: normal !important;
}

.actions-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
}

.workflow-closed {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #22c55e;
  font-size: var(--text-xs2);
  font-weight: 500;

  .checkmark-icon {
    background: #22c55e;
    color: white;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--text-xs1);
    font-weight: bold;
  }
}

.action-dropdown {
  flex: 1;
  min-width: 0;
  position: relative;

  .dropdown-container {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .dropdown-trigger {
    flex: 0 0 160px;
    height: 25px;
    padding: 4px 8px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background: white;
    font-size: var(--text-s);
    color: #374151;
    max-width: 160px;
    width: 160px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.2s ease;

    &:hover {
      border-color: #9ca3af;
    }

    &:focus {
      outline: none;
      border-color: #3b82f6;
      box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);
    }

    &.dropdown-open {
      border-color: #3b82f6;
      box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background-color: #f9fafb;
    }

    .dropdown-text {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .dropdown-arrow {
      flex-shrink: 0;
      margin-left: 4px;
      transition: transform 0.2s ease;

      &.dropdown-arrow-open {
        transform: rotate(180deg);
      }
    }
  }

  .dropdown-content {
    position: fixed;
    z-index: 9999;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    margin-top: 2px;
    overflow: hidden;
    animation: dropdownFadeIn 0.15s ease-out;
    width: 160px;
    min-width: 160px;
  }

  .dropdown-group {
    &:not(:last-child) {
      border-bottom: 1px solid #f3f4f6;
    }
  }

  .dropdown-label {
    padding: 8px 12px 4px 12px;
    font-size: var(--text-xs2);
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .action-buttons {
    display: flex;
    gap: 4px;

    .save-btn,
    .cancel-btn {
      padding: 4px 8px;
      font-size: var(--text-xs2);
      border-radius: 3px;
      border: 1px solid #d1d5db;
      cursor: pointer;
      transition: all 0.2s ease;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .save-btn {
      background-color: #3b82f6;
      color: white;
      border-color: #3b82f6;

      &:hover:not(:disabled) {
        background-color: #2563eb;
        border-color: #2563eb;
      }
    }

    .cancel-btn {
      background-color: white;
      color: #374151;

      &:hover {
        background-color: #f9fafb;
      }
    }
  }

  .dropdown-item {
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: background-color 0.15s ease;
    border: 1px solid transparent;
    box-sizing: border-box;

    &:hover {
      background-color: #f9fafb;
    }

    &.selected {
      background-color: #dbeafe;
      border: 1px solid transparent;
      box-sizing: border-box;

      &:hover {
        background-color: #bfdbfe;
      }
    }

    &.dropdown-item-close {
      border-top: 1px solid #f3f4f6;

      &:hover {
        background-color: #fef2f2;
      }
    }

    &.dropdown-item-finish {
      &:hover {
        background-color: #f0f9ff;
      }
    }
  }

  .dropdown-item-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 8px;
    margin: 0;
    box-sizing: border-box;
    width: 100%;
  }

  .dropdown-item-text {
    font-size: var(--text-xs2);
    color: #000000;
    flex: 1;
    font-weight: 500;
  }

  .dropdown-item-icon {
    font-size: var(--text-xs1);
    margin-left: 8px;
    opacity: 0.7;
  }

  .dropdown-separator {
    height: 1px;
    background-color: #e5e7eb;
    margin: 4px 0;
  }
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.pagination-section {
  padding: 4px 0 0px 0;

  .total-count {
    font-size: var(--text-xs2);
    color: #666;

    b {
      font-weight: 600;
    }
  }

  // Style pagination component
  ::v-deep .pagination-2 {
    font-size: var(--text-xs2);

    .nav-button,
    .page-button {
      font-size: var(--text-xs2);
      padding: 4px 8px;
      min-width: 28px;
      height: 28px;
      border-radius: 4px;
    }

    .pagination-input {
      font-size: var(--text-xs2);
      height: 28px;
      width: 40px;
    }
  }
}
.copy-dtx-table {
  max-height: none;
}
.disabled-dd {
  pointer-events: none;
  opacity: 0.5;
}
.selected-row{
    background-color: var(--gray-bgcolor);
    transition: background 0.2s ease-in-out;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
}
.qr-header {
  width: 60px;
  text-align: center;
}

.qr-cell {
  text-align: center;
}

.qr-code-btn {
  border: none;
  background: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #000;
  cursor: pointer;
}

.qr-code-btn:hover {
  color: #333;
}

.qr-code-btn.qr-disabled {
  color: #b8b8b8;
  cursor: not-allowed;
  pointer-events: none;
}

.qr-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;;
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

// @media (min-width: 560px) {
//   .qr-code-container {
//     flex-direction: row;
//     align-items: flex-start;
//   }
// }

.qr-code-display {
  min-height: 180px;
  min-width: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d7d7d7;
  border-radius: 8px;
  padding: 16px;
}

.qr-loading {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  color: #666;
}

.qr-code-display img {
  max-width: 220px;
  max-height: 220px;
}

.qr-info {
  text-align: center;
}

.qr-info-title {
  font-weight: 600;
  margin-bottom: 4px;
}

.qr-info-subtitle {
  font-size: var(--text-m);
  color: #666;
}

.qr-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
